/**
 * @ngdoc directive
 * @name phoenix.directive:pxChipsClearOnBlur
 * @module phoenix
 * @restrict A
 * @description
 *
 * A directive to auto remove the value left in the md-chips interface's input 
 *
 * @usage
 *
 * <md-chips px-chips-clear-on-blur />
 *
 */
export function ChipsClearOnBlurDirective($interval, $timeout) {
	return {
		restrict: 'A',
		require: 'mdChips',
		link: function (scope, element, attrs, chipsCtrl) {
			if (!chipsCtrl || chipsCtrl.readonly) { return; }

			// amount of time in MS with which to poll for an input
			var pollingThreshold = 6000; 
			var trigger = null;				
			var start = Date.now();
			var timedOut = false;
			var input = null;
			var interval = $interval(function () {
				timedOut = (Date.now() - start) >= pollingThreshold;
				input = element.find('input');

				if (input.length === 1) {
					$interval.cancel(interval);			
					input[0].addEventListener('blur', triggerRemove);
				}
				else if (timedOut) {
					$interval.cancel(interval);	
				}
			}, 100);

			function triggerRemove() {
				//timeout to allow user to pick from autocomplete
				$timeout(removeValue, 500);
			}

			function removeValue() {
				$timeout.cancel(trigger);
				//clear the value
				if (input.val() !== '') {
					input.val('');
					//clear chips search text
					chipsCtrl.searchText = '';
				}
			}

			scope.$on('$destroy', function () {
				if(input && input.length > 0) {
					input[0].removeEventListener('blur', removeValue);
				}
			});
		}
	};
}

ChipsClearOnBlurDirective.$inject =  [
	'$interval',
	'$timeout'
];



// WEBPACK FOOTER //
// ./src/phoenix/components/chipsClearOnBlur/chipsClearOnBlur.ts